export default __webpack_public_path__ + "static/media/jema11.dbc48cbf.png";